import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoaderComponent } from "./components/loader/loader.component";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { ContentLayoutComponent } from "./components/layout/content-layout/content-layout.component";
import { FullLayoutComponent } from "./components/layout/full-layout/full-layout.component";
import { FeatherIconsComponent } from "./components/feather-icons/feather-icons.component";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { BookmarkComponent } from "./components/bookmark/bookmark.component";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// services
import { NavService } from "./services/nav.service";
import { CustomizerService } from "./services/customizer.service";
// Directives
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { UserService } from "./services/user.service";
import { ClientService } from "./services/client.service";
import { TeamService } from "./services/team.service";
import { LeagalServiceService } from "./services/leagal-service.service";
import { NgbdSortableHeader } from "./directives/NgbdSortableHeader";
import { ModalComponent } from "./components/modal/modal.component";
import { FormWrapperBuilderComponent } from "../components/sample-page/form-wrapper-builder/form-wrapper-builder.component";
import { FormGroupWrapperBuilderComponent } from "../components/sample-page/form-group-wrapper-builder/form-group-wrapper-builder.component";
import { ScheduleRegistrationComponent } from "../components/sample-page/schedule-registration/schedule-registration.component";
import { EditScheduleRegistrationComponent } from "../components/sample-page/schedule-registration copy/edit-schedule-registration.component";
import { UpdatePaymentDiscountComponent } from "../components/sample-page/update-payment-discount/update-payment-discount.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [LoaderComponent, HeaderComponent, FooterComponent, SidebarComponent, BookmarkComponent, ContentLayoutComponent, FullLayoutComponent, FeatherIconsComponent, BreadcrumbComponent,NgbdSortableHeader, FormWrapperBuilderComponent,FormGroupWrapperBuilderComponent,ScheduleRegistrationComponent,EditScheduleRegistrationComponent,UpdatePaymentDiscountComponent],
  imports: [CommonModule, RouterModule, FormsModule,ReactiveFormsModule, TranslateModule, NgbModule,FormsModule],
  exports: [LoaderComponent, FeatherIconsComponent, TranslateModule,NgbdSortableHeader, FormWrapperBuilderComponent,FormGroupWrapperBuilderComponent,ScheduleRegistrationComponent,EditScheduleRegistrationComponent,UpdatePaymentDiscountComponent],
  providers: [NavService, CustomizerService,UserService,ClientService,TeamService,LeagalServiceService],
})
export class SharedModule {}